<div [ngClass]="opens == 'right' ? 'left icon' : 'icon'" [class.disabled]="disabled" class="ui input">
  <input #elementRef type="daterange" [readonly]="!editable">
  <i class="calendar alternate outline icon"></i>
</div>
